<template>
  <nuttrema-layout-schedules
     class="is-no-middle-margin-top is-no-wide-stripe"
     widthEast="20em"
    :showEast="true"
    :toggleShowEast="false">

    <template slot="central">

      <nuttrema-form-alert
         style="margin-bottom: 1em"
        :error="_get(InstancePlanPurchaseCheckout, 'error')">
      </nuttrema-form-alert>

      <nuttrema-layout-form-standard
         theme="purchase"
         ref="ref-layout-form-standard"
         class="is-payment-form"
        :edit="true">
        <template slot="center">
          <el-form
             label-width="25%"
            :rules="rules"
            :ref="formRef"
            :model="formData"
            :validate-on-rule-change="false"
            :label-position="labelPosition">

            <resize-observer @notify="onResize"></resize-observer>

            <section>
              <h4 class="section-title">{{ $t('label.payment_information') }}</h4>
              <div class="section-items">

                <el-form-item
                   class="el-form-item--w-50"
                  :label="$t('label.plan')">
                  <el-input :value="_get(SubscriptionReview, 'data.SubscribedPlan.name')" disabled></el-input>
                </el-form-item>

                <el-form-item
                   prop="payment_plan_id"
                   class="el-form-item--w-50"
                  :label="$t('label.payment_plan')">
                  <el-input :value="`${_get(SubscriptionReview, 'data.SubscribedPlan.PaymentPlan.name')} (${$t('label.months_number', { months: _get(SubscriptionReview, 'data.SubscribedPlan.PaymentPlan.months', 0) }) })`" disabled></el-input>
                </el-form-item>

                <template v-if="formData.payment_method === PAYMENT_METHOD.BANK_TRANSFER">
                  <el-form-item
                     prop="auto_renewal"
                     style="margin-bottom: 0"
                    :label="getPlaceholderText($t('label.auto_renewal'))">
                    <el-switch :value="false" active-color="#ffdd57" :disabled="true"></el-switch>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item
                     prop="auto_renewal"
                     style="margin-bottom: 0"
                    :label="getPlaceholderText($t('label.auto_renewal'))">
                    <el-switch v-model="formData.auto_renewal" active-color="#ffdd57"></el-switch>
                    <p class="el-form-item__help" v-if="isTrial" style="padding: 0.75em 0.25em">
                      * {{ $t('label.not_required_for_trial_plan') }}
                    </p>
                    <p class="el-form-item__help" v-if="!isTrial && formData.auto_renewal" style="padding: 0.75em 0.25em">
                      {{ $t('label.auto_renewal_help') }}
                    </p>
                  </el-form-item>
                </template>
              </div>
            </section>

            <section>
              <div class="section-title">{{ $t('label.payment_method') }}</div>

              <div class="section-items is-small-padding">
                <el-collapse v-model="formData.payment_method" accordion @change="onPaymentMethodChange">

                  <el-collapse-item v-if="_get(SubscriptionReview, 'data.Person.PaymentSources', []).length > 0" :title="$t('label.saved_cards')" :name="PAYMENT_METHOD.SAVED_SOURCE">
                    <el-form-item class="el-form-item--w-50" prop="payment_source_id">
                      <el-radio
                         v-for="source in _get(SubscriptionReview, 'data.Person.PaymentSources')"
                         v-model="formData.payment_source_id"
                         class="is-cc"
                        :key="source.id"
                        :label="source.id">
                        <i :class="[`fab ${getCreditCardIcon(source.brand)}`]"></i> {{ source.brand }} {{ $t('label.ending_in') }} {{ source.last4 }}
                      </el-radio>
                    </el-form-item>
                  </el-collapse-item>

                  <el-collapse-item :title="$t('label.add_new_card')" name="stripe_source">
                    <el-form-item :label="$t('label.owner_name')" class="el-form-item--w-50" prop="owner_name">
                      <el-input v-model="formData.owner_name"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('label.card')" class="el-form-item--w-50" prop="card">
                      <card
                         class="stripe-card"
                        :class="{ 'complete': stripe.complete, 'is-active': stripe.focus }"
                        :stripe="stripe.key"
                        :options="stripe.options"
                        @change="creditCardChanged"
                        @focus="stripeCardFocus"
                        @blur="stripeCardBlur">
                      </card>
                    </el-form-item>

                    <el-form-item :label="$t('label.billing_address')">
                      <el-row>
                        <el-col :span="18">
                          <el-input v-model="formData.PersonData.address_street.value" :placeholder="$t('label.street')"></el-input>
                        </el-col>
                        <el-col :span="5" :offset="1">
                          <el-input v-model="formData.PersonData.address_house_no.value" :placeholder="$t('label.house_no')"></el-input>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="9">
                          <el-input v-model="formData.PersonData.address_city.value" :placeholder="$t('label.city')"></el-input>
                        </el-col>
                        <el-col :span="4" :offset="1">
                          <el-form-item prop="PersonData.address_zip.value">
                            <el-input v-model="formData.PersonData.address_zip.value" :placeholder="getPlaceholderText($t('label.zip'))"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="9" :offset="1">
                          <el-form-item prop="region_id">
                            <el-cascader
                               v-model="formData.region_id"
                               class="w-100"
                              :clearable="true"
                              :filterable="true"
                              :placeholder="getPlaceholderText($t('label.country'))"
                              :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                              :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                              :show-all-levels="false">
                            </el-cascader>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-collapse-item>

                  <el-collapse-item :title="$t('label.bank_transfer')" name="bank_transfer">
                    <el-form-item prop="region_id" class="el-form-item--w-60" :label="$t('label.country')">
                      <el-cascader
                         v-model="formData.region_id"
                         class="w-100"
                        :clearable="true"
                        :filterable="true"
                        :placeholder="getPlaceholderText($t('label.country'))"
                        :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                        :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                        :show-all-levels="false">
                      </el-cascader>
                    </el-form-item>
                    <el-form-item>
                      <p style="line-height: 1.75; font-weight: bold; margin-left: 0.25em; margin-top: 1em; margin-bottom: 0.5em">{{ $t('label.bank_transfer_instructions') }}</p>
                      <p style="line-height: 1.75; margin-left: 0.25em">
                        {{ $t('label.bank_transfer_instruction_help_01') }}<br/>
                        <strong>{{ $t('label.bank_transfer_instruction_help_02') }}</strong><br/>
                        <strong>{{ $t('label.bank_transfer_instruction_help_03') }}</strong><br/>
                        {{ $t('label.bank_transfer_instruction_help_04') }}<br/>
                        {{ $t('label.bank_transfer_instruction_help_05') }}<br/>
                        {{ $t('label.bank_transfer_instruction_help_06') }}<br/>
                        {{ $t('label.bank_transfer_instruction_help_07') }}
                      </p>
                  </el-form-item>
                  </el-collapse-item>

                </el-collapse>
              </div>

              <div class="section-help">
                <p class="features__note--text" style="padding: 0">
                  <div class="powered_by_stripe__logo"></div>
                </p>
                <p class="features__note--text" style="padding: 0 0.25em">
                  {{ $t('label.stripe_pci_note') }}
                  <br/>
                  <a href="https://stripe.com/docs/security/stripe" target="_blank" ref="no-follow">{{ $t('label.more_info') | lowercase }}...</a>
                </p>
              </div>
            </section>

          </el-form>
        </template>
      </nuttrema-layout-form-standard>
    </template>
    <!-- end ~ central -->


    <template slot="east">
      <subscription-east-summary-review-plan
         class="is-in-new-purchase"
        :summary="_get(SubscriptionReview, 'data.SubscribedPlan')"
        :preconditions="_get(SubscriptionReview, 'meta.preconditions')"
        :paymentPlanID="formData.payment_plan_id"
        :autoRenewal="formData.auto_renewal"
        :taxRate="taxRate"
        :processing="processing"
        @proceedWithPayment="proceedWithPayment"
        @previousStep="previousStep">
      </subscription-east-summary-review-plan>
    </template>
    <!-- end ~ east -->


  </nuttrema-layout-schedules>
</template>

<script>
/* eslint-disable object-shorthand */
import { get, set } from 'lodash';
import { ResizeObserver } from 'vue-resize';

import { PAYMENT_METHOD } from 'constants/values';

import NuttremaLayoutSchedules from 'components/ui/layout/nuttrema-layout-schedules';

import SubscriptionPlanReviewAbstract from './cmpt-subscription-plan-review-abstract';

import SubscriptionEastSummaryReviewPlan from './cmpt-subscription-east-summary-review-plan';


export default {
  name: 'cmpt-instance-purchase-new-review',
  mixins: [SubscriptionPlanReviewAbstract],
  props: {
    InstancePlanPurchaseCheckout: {
      required: true,
      default: null,
    },
  },
  components: {
    ResizeObserver,
    NuttremaLayoutSchedules,
    SubscriptionEastSummaryReviewPlan,
  },
  data() {
    return {
      labelPosition: 'right',
    };
  },
  methods: {
    onResize() {
      const form = this.$refs['ref-layout-form-standard'];
      const width = get(form, '$el.clientWidth', 0);
      this.labelPosition = width <= 600 ? 'top' : 'right';
    },
    getCreditCardIcon(brand) {
      // American Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown
      let card = 'fa-credit-card';

      switch (brand) {
        case 'American Express':
          card = 'fa-cc-amex';
          break;
        case 'Diners Club':
          card = 'fa-cc-diners-club';
          break;
        case 'Discover':
          card = 'fa-cc-discover';
          break;
        case 'JCB':
          card = 'fa-cc-jcb';
          break;
        case 'MasterCard':
          card = 'fa-cc-mastercard';
          break;
        case 'UnionPay':
          card = 'fa-cc-stripe';
          break;
        case 'Visa':
          card = 'fa-cc-visa';
          break;
        default:
          card = 'fa-credit-card';
          break;
      }

      return card;
    },
    createRules() {
      const rules = {};

      // Saved credit cards
      if (this.formData.payment_method === PAYMENT_METHOD.SAVED_SOURCE) {
        set(rules, 'payment_source_id', [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.credit_card', true),
          },
        ]);
      }

      // Bank transfer
      if (this.formData.payment_method === PAYMENT_METHOD.STRIPE_SOURCE) {
        set(rules, 'owner_name', [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.owner_name', true),
          },
        ]);

        set(rules, 'region_id', [
          {
            type: 'array',
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.country', true),
          },
        ]);

        set(rules, 'PersonData.address_zip.value', [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.zip', true),
          },
        ]);

        set(rules, 'card', [
          {
            required: true,
            trigger: 'change',
            message: this.formatValidationMessage('validation.required', 'label.card', true),
          },
        ]);
      }
      // if stripe source

      this.rules = rules;
    },
  },
  watch: {
    'InstancePlanPurchaseCheckout.saving': {
      handler: function (newValue) {
        if (!newValue) this.processing = false;
      },
      deep: true,
    },
  },
  created() {
    this.formRef = 'form-instance-purchase-new-review';
    this.$nextTick(() => {
      this.onResize();
    });
  },
};
</script>




// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-instance-purchase-new-review.vue